// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  citizenId: __t.u64().primaryKey().name("citizen_id"),
  cityId: __t.u64().name("city_id"),
  identity: __t.identity(),
  residenceStructureId: __t.u64().name("residence_structure_id"),
  isMilitia: __t.bool().name("is_militia"),
  declaredAt: __t.timestamp().name("declared_at"),
});
